(function () {
  'use strict';

  var CHAT_TIMEOUT_MS = 1500;
  var DEBOUNCE_MS = 2000;
  var STORAGE_KEY = 'apolla_event_queue';
  var STORAGE_LIMIT = 50;

  var firedContexts = {};
  var pendingTimeouts = {}; // CRITICAL-1 fix: track per-context timeout handles to cancel on success

  function safeStoredQueue() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      try {
        return JSON.parse(raw);
      } catch (parseErr) {
        // CRITICAL-2 fix: corrupt value self-heal — clear so next click starts fresh
        window.localStorage.removeItem(STORAGE_KEY);
        return [];
      }
    } catch (_) {
      // private mode / quota / SecurityError — silent ok
      return [];
    }
  }

  function logEvent(name, ctx, ts, status) {
    var evt = { event: name, context: ctx, ts: ts };
    if (status) evt.status = status;
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      try { window.dataLayer.push(evt); return; } catch (_) {}
    }
    try {
      var queue = safeStoredQueue();
      queue.push(evt);
      if (queue.length > STORAGE_LIMIT) queue = queue.slice(-STORAGE_LIMIT);
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(queue));
      } catch (_) { /* quota - silent ok for analytics-only */ }
    } catch (_) { /* defensive */ }
  }

  function openChat() {
    // FYS_VERA_OPEN_FN_v2 — cutover 2026-08-10. Fin/Intercom was retired and Vera is the
    // live chat, so the v1 body opened nothing and every CTA silently fell through to
    // its fallback URL.
    // Vera runs in a cross-origin iframe, so only its loader (vera-embed.js) can reach
    // it; the loader exposes window.Vera.open(), which returns true ONLY once the
    // message reached a loaded frame. A false leaves the 1500ms fallback below armed,
    // while the loader still queues the open — so a frame that loads late opens anyway
    // and the re-check inside the timeout succeeds. A frame that never loads (blocked
    // by an extension, or down) keeps failing, and the shopper gets the fallback URL.
    if (window.Vera && typeof window.Vera.open === 'function') {
      return window.Vera.open() === true;
    }
    return false;
  }

  window.Apolla = window.Apolla || {};

  // CONSIDER-3 fix: don't overwrite if a prior load (or third-party script) already defined it.
  if (!window.Apolla.openStyleHelper) {
    // CUTOVER POINT — replace the body of openChat() with the chat widget's open API if
    // the widget is ever swapped again. No other code in this file changes.
    window.Apolla.openStyleHelper = function (context, fallbackUrl) {
      var ctx = context || 'unknown';
      var now = Date.now();

      if (firedContexts[ctx] && (now - firedContexts[ctx]) < DEBOUNCE_MS) return;
      firedContexts[ctx] = now;

      // CRITICAL-5 fix: log click intent immediately; log open status separately when chat actually opens.
      logEvent('find_your_style_click', ctx, now);

      if (openChat()) {
        logEvent('find_your_style_open', ctx, Date.now(), 'vera');
        return;
      }

      // CRITICAL-1 fix: cancel any prior pending timeout for this context (re-arm window).
      if (pendingTimeouts[ctx]) clearTimeout(pendingTimeouts[ctx]);

      pendingTimeouts[ctx] = setTimeout(function () {
        delete pendingTimeouts[ctx];
        // Re-check chat availability inside the timeout — the loader may have hydrated since click.
        if (openChat()) {
          logEvent('find_your_style_open', ctx, Date.now(), 'vera_late');
          return;
        }
        if (fallbackUrl) {
          logEvent('find_your_style_open', ctx, Date.now(), 'fallback_url');
          window.location.href = fallbackUrl;
        } else {
          logEvent('find_your_style_open', ctx, Date.now(), 'silent_noop');
        }
      }, CHAT_TIMEOUT_MS);
    };
  }

  // External-link auto-open: fires Apolla.openStyleHelper if URL has ?open_style_helper=1.
  function autoOpenFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('open_style_helper') !== '1') return;
      var src = (params.get('src') || 'external-link').replace(/[^a-z0-9_-]/gi, '').slice(0, 64);
      var ctx = 'ext-' + (src || 'external-link');

      // CRITICAL-4 fix: strip params from URL after consumption so refresh/back doesn't re-fire.
      try {
        params.delete('open_style_helper');
        params.delete('src');
        var qs = params.toString();
        var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', newUrl);
        }
      } catch (_) { /* history API unavailable - silent ok */ }

      var attempts = 0;
      (function tryOpen() {
        if ((window.Vera && typeof window.Vera.open === 'function') || attempts > 6) {
          window.Apolla.openStyleHelper(ctx, '');
        } else {
          attempts++;
          setTimeout(tryOpen, 500);
        }
      })();
    } catch (_) { /* malformed URL - silent ok */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoOpenFromUrl);
  } else {
    autoOpenFromUrl();
  }

  // CAUTION-2 fix: delegated click listener uses [data-fys-cta] sentinel, not class.
  // Class is cosmetic only; data attribute is the click contract.
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-fys-cta]');
    if (!el) return;
    e.preventDefault();
    var ctx = el.getAttribute('data-fys-context') || 'unknown';
    var fb = el.getAttribute('data-fys-fallback') || '';
    window.Apolla.openStyleHelper(ctx, fb);
  }, false);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('[data-fys-cta]');
    if (!el) return;
    if (el.tagName === 'BUTTON' || el.tagName === 'A') return; // native handles Enter/Space
    e.preventDefault();
    var ctx = el.getAttribute('data-fys-context') || 'unknown';
    var fb = el.getAttribute('data-fys-fallback') || '';
    window.Apolla.openStyleHelper(ctx, fb);
  }, false);

  // CRITICAL-3 fix: image-tile fallback — per-image error/load listeners + window.load backup.
  function applyImageFallback(img) {
    if (!img || img.style.display === 'none') return;
    img.style.display = 'none';
    if (img.parentNode) img.parentNode.classList.add('fys-cta--tile-fallback');
  }
  function setupImageFallback(img) {
    if (img.dataset.fysFallbackBound === '1') return; // idempotent
    img.dataset.fysFallbackBound = '1';
    img.addEventListener('error', function () { applyImageFallback(img); });
    if (img.complete && img.naturalWidth === 0) applyImageFallback(img);
  }
  function setupAllImageFallbacks() {
    var imgs = document.querySelectorAll('.fys-cta--tile img');
    for (var i = 0; i < imgs.length; i++) setupImageFallback(imgs[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAllImageFallbacks);
  } else {
    setupAllImageFallbacks();
  }
  window.addEventListener('load', setupAllImageFallbacks);

  // localStorage event-queue flush on next dataLayer-ready page load.
  window.addEventListener('load', function () {
    if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
    try {
      var queue = safeStoredQueue();
      if (!queue.length) return;
      queue.forEach(function (evt) { window.dataLayer.push(evt); });
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  });
})();
